import { Component } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { DetailTepProjetComponent } from '../../edition/detail-tep-projet/detail-tep-projet.component';

interface HierarchicalItem {
  type: 'programme' | 'action' | 'activite' | 'tache';
  id: number;
  code: string;
  libelle: string;
  date_debut: string | null;
  date_fin: string | null;
  poids: number | string;
  montant: number;
  responsable: string | null;
  children?: HierarchicalItem[];
  isExpanded?: boolean;
  level?: number;
  parentId?: number;
  visible:any

}
@Component({
  selector: 'app-pta-by-periode',
  standalone: false,
  templateUrl: './pta-by-periode.component.html',
  styleUrl: './pta-by-periode.component.scss'
})

export class PtaByPeriodeComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  projetData: any = [] = [];
  annee: any;
  modalRef: NgbModalRef | null = null;
  isLoading: boolean = false;
  searchTerm: string = '';
  dateDebut: string;
  dateFin: string;
  itemToDelete!: ProjetIndicateur;
  filteredtems: any = [];
  projetId: any
  pageSize: number = 10;
  pdfUrl: string;
  excelUrl: string;

  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];

  projetItems: any = [];
  expandedRows: { [key: string]: boolean } = {};
  selectedProjet: any;
  directionId: any;
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any;
  selectedDirection: any = {};
  selectedService: any = {};
  serviceItems: any = [];
  projetDataSource: any[] = [];
  displayedItems: HierarchicalItem[] = [];
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
     this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${ this.annee}-01-01`;
    this.dateFin = `${ this.annee}-12-31`;
  }

  ngOnInit(): void {

    this.projetId = this.localstorage.getProjetToUser();
    //this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.userInfo = this.localstorage.getInfoUserToService();

    if (this.userInfo?.data?.groupe === "admin") {

      this.showFiltre = true;
      this.getDirection();
    }
    if (this.userInfo?.data?.groupe === "point_focal") { //TODO: pourquoi on ne laisse pas le ws faire ce filtrage?
      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;
      this.getProjetByDirection(this.directionId);
    }

     if (this.annee) {
    this.dateDebut = `${this.annee}-01-01`;
    this.dateFin = `${this.annee}-12-31`;
  }
  }

  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data;
        this.getService()
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    )
  }

  getService() {
    this.paramservice.fetchDataService().subscribe(
      (response: any) => {
        this.serviceItems = response.data
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    )
  }
  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
        // this.getExercice();
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);
      }
    )

  }

  //recuperation des statistiques
  getStatistique() {
    if (!this.dateDebut || !this.dateFin) {
      this.messageService.add({
        severity: 'error',
        summary: 'TEP',
        detail: 'Veuillez renseigner les dates',
        life: 3000
      });
      return;
    }

    this.isLoading = true;
    this.ngxService.start();

    this.paramservice.getStatistiquePtaByPeriode(
      this.annee,
      this.dateDebut,
      this.dateFin,
      this.userInfo?.data?.reference
    ).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.isLoading = false;
        this.projetDataSource = response.data;
        this.buildHierarchy();
      },
      (error: any) => {
        this.ngxService.stop();
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de récupérer les données',
          life: 3000
        });
      }
    );
  }

  /**
   * Construit la hiérarchie à partir des données plates
   */
/**
 * Construit la hiérarchie à 4 niveaux
 */
buildHierarchy() {
  const hierarchy: HierarchicalItem[] = [];
  let currentProgramme: HierarchicalItem | null = null;
  let currentAction: HierarchicalItem | null = null;
  let currentActivite: HierarchicalItem | null = null;

  this.projetDataSource.forEach(item => {
    const hierarchicalItem: HierarchicalItem = {
      ...item,
      children: [],
      isExpanded: false, // Tout est replié par défaut
      level: 0,
      visible: true // Seuls les programmes sont visibles au départ
    };

    switch (item.type) {
      case 'programme':
        // Niveau 0 : Programme
        hierarchicalItem.level = 0;
        hierarchicalItem.visible = true; // Visible au départ
        hierarchy.push(hierarchicalItem);
        currentProgramme = hierarchicalItem;
        currentAction = null;
        currentActivite = null;
        break;

      case 'action':
        // Niveau 1 : Action (enfant de Programme)
        hierarchicalItem.level = 1;
        hierarchicalItem.visible = false; // Caché au départ
        if (currentProgramme) {
          currentProgramme.children.push(hierarchicalItem);
          currentAction = hierarchicalItem;
          currentActivite = null; // Réinitialiser l'activité courante
        }
        break;

      case 'activite':
        // Niveau 2 : Activité (enfant d'Action)
        hierarchicalItem.level = 2;
        hierarchicalItem.visible = false; // Caché au départ
        if (currentAction) {
          currentAction.children.push(hierarchicalItem);
          currentActivite = hierarchicalItem;
        } else if (currentProgramme) {
          // Cas spécial : activité directement sous programme
          hierarchicalItem.level = 1;
          currentProgramme.children.push(hierarchicalItem);
        }
        break;

      case 'tache':
        // Niveau 3 : Tâche (enfant d'Activité)
        hierarchicalItem.level = 3;
        hierarchicalItem.visible = false; // Caché au départ
        if (currentActivite) {
          currentActivite.children.push(hierarchicalItem);
        } else if (currentAction) {
          // Cas spécial : tâche directement sous action
          hierarchicalItem.level = 2;
          currentAction.children.push(hierarchicalItem);
        } else if (currentProgramme) {
          // Cas spécial : tâche directement sous programme
          hierarchicalItem.level = 1;
          currentProgramme.children.push(hierarchicalItem);
        }
        break;

      default:
        // Type non reconnu
        hierarchicalItem.level = 1;
        hierarchicalItem.visible = false;
        if (currentProgramme) {
          currentProgramme.children.push(hierarchicalItem);
        }
    }
  });

  this.projetData = hierarchy;
  this.updateDisplayedItems();
}

/**
 * Bascule l'état déplié/replié d'un item
 */
toggleExpand(item: HierarchicalItem, event?: Event) {
  if (event) {
    event.stopPropagation();
  }

  // Si l'item n'a pas d'enfants, ne rien faire
  if (!this.hasChildren(item)) {
    return;
  }

  // Bascule l'état
  const wasExpanded = item.isExpanded;
  item.isExpanded = !item.isExpanded;

  // Gérer la visibilité des enfants
  this.updateVisibilityForChildren(item, item.isExpanded);

  // Si on replie un élément, on doit aussi replier tous ses descendants
  if (wasExpanded && !item.isExpanded) {
    this.collapseAllDescendants(item);
  }

  this.updateDisplayedItems();
}

/**
 * Met à jour la visibilité des enfants directs
 */
updateVisibilityForChildren(parent: HierarchicalItem, isVisible: boolean) {
  if (!parent.children || parent.children.length === 0) {
    return;
  }

  parent.children.forEach(child => {
    // Les enfants directs deviennent visibles/invisibles
    child.visible = isVisible;
  });
}

/**
 * Replie tous les descendants d'un élément
 */
collapseAllDescendants(item: HierarchicalItem) {
  if (!item.children || item.children.length === 0) {
    return;
  }

  item.children.forEach(child => {
    child.isExpanded = false;
    child.visible = false; // Les enfants deviennent invisibles
    this.collapseAllDescendants(child);
  });
}

/**
 * Aplatit la hiérarchie pour l'affichage en tenant compte de la visibilité
 */
flattenHierarchy(items: HierarchicalItem[], level: number) {
  items.forEach(item => {
    // N'afficher que si visible OU si c'est un programme (toujours visible)
    if (!item.visible && item.type !== 'programme') {
      return;
    }

    // Appliquer le niveau hiérarchique pour l'indentation
    item.level = level;
    this.displayedItems.push(item);

    // Si l'item est déplié et a des enfants visibles, continuer
    if (item.isExpanded && item.children && item.children.length > 0) {
      this.flattenHierarchy(item.children, level + 1);
    }
  });
}

/**
 * Déplier tout : tous les niveaux deviennent visibles
 */
expandAll() {
  const setAllExpanded = (items: HierarchicalItem[], level: number) => {
    items.forEach(item => {
      item.isExpanded = true;
      item.visible = true;

      if (item.children && item.children.length > 0) {
        setAllExpanded(item.children, level + 1);
      }
    });
  };

  setAllExpanded(this.projetData, 0);
  this.updateDisplayedItems();
}

/**
 * Replier tout : seul le niveau programme reste visible
 */
collapseAll() {
  const setAllCollapsed = (items: HierarchicalItem[]) => {
    items.forEach(item => {
      item.isExpanded = false;

      // Seuls les programmes restent visibles
      item.visible = item.type === 'programme';

      if (item.children && item.children.length > 0) {
        setAllCollapsed(item.children);
      }
    });
  };

  setAllCollapsed(this.projetData);
  this.updateDisplayedItems();
}

  /**
   * Détermine le niveau hiérarchique basé sur le code
   */
  getLevel(code: string): number {
    const parts = code.split('.');
    return parts.length - 1;
  }

  /**
   * Obtient le code du parent
   */
  getParentCode(code: string): string {
    const parts = code.split('.');
    parts.pop(); // Enlever le dernier segment
    return parts.join('.');
  }

  /**
   * Bascule l'état déplié/replié d'un item

  /**
   * Met à jour la liste des items à afficher
   */
  updateDisplayedItems() {
    this.displayedItems = [];
    this.flattenHierarchy(this.projetData, 0);
  }

  /**
   * Aplatit la hiérarchie pour l'affichage
   */


  /**
   * Vérifie si un item a des enfants
   */
  hasChildren(item: HierarchicalItem): boolean {
    return !!(item.children && item.children.length > 0);
  }

  /**
   * Obtient l'icône appropriée pour l'état de dépliage
   */
  getExpandIcon(item: HierarchicalItem): string {
    if (!this.hasChildren(item)) {
      return '';
    }
    return item.isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right';
  }

  /**
 * Retourne le libellé formaté pour le type
 */
getTypeLabel(type: string): string {
  const labels: { [key: string]: string } = {
    'programme': 'PROGRAMME',
    'action': 'ACTION',
    'activite': 'ACTIVITÉ',
    'tache': 'TÂCHE'
  };
  return labels[type] || type.toUpperCase();
}
  /**
   * Obtient la classe CSS pour le type d'item
   */
  getItemClass(type: string): string {
    const classes: { [key: string]: string } = {
      'programme': 'item-programme',
      'action': 'item-action',
      'activite': 'item-activite',
      'tache': 'item-tache'
    };
    return classes[type] || '';
  }

  /**
   * Formate le montant
   */
  formatMontant(montant: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XOF',
      minimumFractionDigits: 0
    }).format(montant);
  }

  /**
   * Formate la date
   */
  formatDate(date: string | null): string {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('fr-FR');
  }

  /**
   * Déplier/Replier tout
   */

  private setExpandState(items: HierarchicalItem[], expanded: boolean) {
    items.forEach(item => {
      item.isExpanded = expanded;
      if (item.children && item.children.length > 0) {
        this.setExpandState(item.children, expanded);
      }
    });
  }

  /**
   * Compte le nombre d'items par type
   */
  countByType(type: string): number {
    let count = 0;

    const countRecursive = (items: HierarchicalItem[]) => {
      items.forEach(item => {
        if (item.type === type) {
          count++;
        }
        if (item.children && item.children.length > 0) {
          countRecursive(item.children);
        }
      });
    };

    countRecursive(this.projetData);
    return count;
  }
//fonction pour basculer l'affichage
toggleRow(type: string, id: any) {
    const key = `${type}_${id}`;
    this.expandedRows[key] = !this.expandedRows[key];
}

//vérifier si une ligne est dépliée
isExpanded(type: string, id: any): boolean {
    return !!this.expandedRows[`${type}_${id}`];
}


  filterByDate(): void {

    if (!this.dateDebut || !this.dateFin) {
      this.messageService.add({
        severity: 'warn',
        summary: 'TEP',
        detail: 'Veuillez renseigner les deux dates',
        life: 3000
      });
      return;
    }

    const start = new Date(this.dateDebut);
    const end = new Date(this.dateFin);

    // this.projetData = this.projetDataSource.filter(item => {

    //   if (!item.date_debut || !item.date_fin) {
    //     return false;
    //   }

    //   const itemStart = new Date(item.date_debut);
    //   const itemEnd = new Date(item.date_fin);

    //   return itemStart >= start && itemEnd <= end;
    // });

    this.totalRecords = this.projetData.length;
    this.updatePaginatedProjets();
  }

  getRowClass(type: string): string {
    switch (type) {
      case 'programme':
        return 'row-programme';
      case 'action':
        return 'row-action';
      case 'activite':
        return 'row-activite';
      case 'tache':
        return 'row-tache';
      default:
        return '';
    }
  }

  getIndent(type: string): number {
    switch (type) {
      case 'programme':
        return 0;
      case 'action':
        return 20;
      case 'activite':
        return 40;
      case 'tache':
        return 60;
      default:
        return 0;
    }
  }

  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets;
    // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.projetData.slice(start, end);
  }//end updatePaginatedProjets


  //imprime en pdf et excel
  exportToDocument(typeDoc: any) {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    this.ngxService.start();

    // save date debut et fin


    //end
    this.paramservice.printStatistiquePtaByPeriode(this.annee, this.directionId, this.dateDebut, this.dateFin, typeDoc, this.userInfo?.data?.reference).subscribe(
      (response: Blob) => {
      let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_PTA_Par_Periode.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_PTA_Par_Periode.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
      (error) => {
        //console.error("Une erreur est survenue", error);
        this.ngxService.stop();
      }
    );
  }//end exportToDocument

  roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
  }


  //detaila ctivite budgetaire
  detailsProjet(item: any) {

    this.localstorage.saveTepProjet(item);

    const modalRef = this.modalService.open(DetailTepProjetComponent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);
  }//end detailsProjet


}
